/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, useState } from 'react'
import { CssTooltip } from '@livechat/design-system'
import infoIcon from '../assets/icons/info-round.svg'

const labelCss = css`
  display: block;
  font-weight: 400;
  font-size: 18px;
  margin: 15px 0 -15px 10px;
  display: flex;
  align-items: center;

  .info {
    > img {
      width: 20px;
      margin-left: 5px;
      margin-bottom: -4px;
      cursor: pointer;
    }
  }
`

const listCss = css`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;
  height: 100%;
  margin-bottom: 50px;

  @media (max-width: 855px) {
    justify-content: center;
  }
`

const SurveysList = ({ label, children, info }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  return (
    <Fragment>
      {label && (
        <span css={labelCss}>
          <span>{label}</span>
          {info && (
            <div
              className="info"
              style={{ display: 'inline-block', position: 'relative' }}
            >
              <img
                src={infoIcon}
                alt="info"
                onMouseEnter={() => setIsTooltipOpen(true)}
                onMouseLeave={() => setIsTooltipOpen(false)}
              />
              <CssTooltip
                placement="bottom"
                isVisible={isTooltipOpen}
                width="200px"
                zIndex={100}
              >
                <div
                  css={css`
                    max-width: 200px;
                    text-align: center;
                  `}
                >
                  {info}
                </div>
              </CssTooltip>
            </div>
          )}
        </span>
      )}

      <div css={listCss}>{children}</div>
    </Fragment>
  )
}

export default SurveysList
